module.exports = __webpack_public_path__ + "img/EDQ04_L.e421d457.png";